import { render, staticRenderFns } from "./AppTag.vue?vue&type=template&id=6bed459f&scoped=true"
import script from "./AppTag.vue?vue&type=script&lang=js"
export * from "./AppTag.vue?vue&type=script&lang=js"
import style0 from "./AppTag.vue?vue&type=style&index=0&id=6bed459f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bed459f",
  null
  
)

export default component.exports